import React from 'react'
import { ScreenContainerProps } from '../../../../@types/props-types'
import withNavigateOnInView from '../../../pages/insertionPage/screens/withNavigateOnInView'

const ScreenContainer: React.FC<ScreenContainerProps> = ({
  containerId,
  style,
  disableMarginBottom,
  className = '',
  children,
}) => (
  <div
    id={containerId}
    data-testid={containerId}
    className={`${className} ${!disableMarginBottom && 'margin-bottom-xxl'}`}
    style={style}
  >
    {children}
  </div>
)

export default withNavigateOnInView(ScreenContainer)
